import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07e67aab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search_div" }
const _hoisted_2 = { class: "input_div" }
const _hoisted_3 = { class: "button_div" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_search, {
        shape: "square",
        onFocus: $setup.search_fn,
        modelValue: _ctx.key_val,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.key_val) = $event)),
        placeholder: $setup.title
      }, null, 8, ["onFocus", "modelValue", "placeholder"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_button, {
          onClick: $setup.search_fn,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _ctx.webpFilters($setup.searchs),
              alt: "",
              class: "searchs-imgs"
            }, null, 8, _hoisted_4)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}